var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"colonne-size"},[_c('b-button-group',_vm._l((_vm.colClasses),function(el){return _c('b-button',{key:("size-" + (el.value)),attrs:{"pressed":_vm.activeCol===el.display},on:{"click":function($event){return _vm.resizeColonne(el.value)}}},[_vm._v(_vm._s(el.display)+"\n    ")])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26cbbb12","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ficheEspace/edit/colonneSize.vue
// module id = null
// module chunks = 